import pako from 'pako';

const FIELD_CANDIDATES = {
  measuredO2: [{ type: 'O2', unit: '%' }],
  measuredCO: [{ type: 'CO', unit: 'ppm' }],
  temperatureBurnedGas: [
    { type: 'FT', unit: '°C' },
    { type: 'TG', unit: '°C' },
  ],
  measuredCO2: [{ type: 'CO2', unit: '%' }],
  burnEfficiency: [
    { type: 'EFFN', unit: '%' },
    { type: 'N', unit: '%' },
  ],
  measuredNO: [
    { type: 'NO2', unit: 'ppm' },
    { type: 'NOX', unit: 'ppm' },
    { type: 'NO', unit: 'ppm' },
  ],
  measuredSO: [
    { type: 'SO2', unit: 'ppm' },
    { type: 'SOX', unit: 'ppm' },
    { type: 'SO', unit: 'ppm' },
  ],
  excessAir: [{ type: 'LAMBDA', unit: '' }],
};

function normalizeTypeName(name) {
  if (!name) return '';
  const subscriptMap = { '₀': '0', '₁': '1', '₂': '2', '₃': '3', '₄': '4', '₅': '5', '₆': '6', '₇': '7', '₈': '8', '₉': '9' };
  return name
    .replace(/[₀₁₂₃₄₅₆₇₈₉]/g, (digit) => subscriptMap[digit])
    .replace(/η/gi, 'N')
    .replace(/λ/gi, 'LAMBDA')
    .trim()
    .replace(/\+$/, '')
    .trim()
    .toUpperCase();
}

function flattenChannels(records) {
  const channels = [];
  records.forEach((record) => {
    (record.channels || []).forEach((channel) => {
      const typeNames = new Set();
      if (channel.type) {
        if (channel.type.name) typeNames.add(normalizeTypeName(channel.type.name));
        if (channel.type.description) typeNames.add(normalizeTypeName(channel.type.description));
      }
      channels.push({
        typeNames,
        unitName: (channel.unit && channel.unit.name) || '',
        values: channel.values || [],
      });
    });
  });
  return channels;
}

function findValue(channels, candidates) {
  for (const candidate of candidates) {
    const matches = channels.filter(
      (channel) => channel.typeNames.has(candidate.type) && channel.unitName === candidate.unit,
    );
    for (const match of matches) {
      const [firstValue] = match.values;
      if (firstValue && firstValue.status !== 'invalid' && firstValue.value !== undefined) {
        return firstValue.value;
      }
    }
  }
  return undefined;
}

export function parseTestoQrPayload(binaryData) {
  const bytes = Uint8Array.from(binaryData);
  const jsonString = pako.ungzip(bytes, { to: 'string' });
  const parsed = JSON.parse(jsonString);
  const records = Array.isArray(parsed) ? parsed : [parsed];
  const channels = flattenChannels(records);

  const result = {};
  Object.entries(FIELD_CANDIDATES).forEach(([field, candidates]) => {
    const value = findValue(channels, candidates);
    if (value !== undefined) {
      result[field] = value;
    }
  });

  return result;
}
